<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/adulte autonomie.png"
        class="card-img-top"
        :alt="$t('autonomieHandicapResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("autonomieHandicapResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("autonomieHandicapResume.text.p1") }}
        <br />
        {{ $t("autonomieHandicapResume.text.p2") }}
      </p>

      <a
        href="/adultes-perte-autonomie-situation-handicap"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("autonomieHandicapResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutonomieHandicapResume",
};
</script>

<style></style>
